import {doCreate} from './apiRequests';
import {ProviderCredentials} from '@/domain/entities/ProviderCredentials';

const PATH = 'op/set-provider-credentials';

const providerCredentialsRepository = {
  post: (dto: Partial<ProviderCredentials>): Promise<ProviderCredentials> =>
    doCreate<Partial<ProviderCredentials>, ProviderCredentials>(PATH, dto),
};

export default providerCredentialsRepository;